import {AxiosInstance} from 'axios';
import TokenService from '../../services/TokenService';
import Token from '../../models/Token';

const tokenInterceptor = (api: AxiosInstance): void => {
    api.interceptors.request.use(
        (config) => {
            const tokens: Token | null = TokenService.getToken();

            if (tokens) {
                config.headers.common.Authorization = `Bearer ${tokens.accessToken}`;
            }

            return config;
        },
        (error) => Promise.reject(error)
    );
};

export default tokenInterceptor;
